import axios from "axios";
import { Preferences } from '@capacitor/preferences'

export const RestApi = async (path:string,method:string,data:any,content:string = 'application/json') => {
  const baseURL = await Preferences.get({key: "url" });
  const token = await Preferences.get({key: "token" });
  let param = '?';
  if (path.includes("?")) {
    param = "&";
  }
  const isFormData = typeof FormData !== 'undefined' && data instanceof FormData;
  return axios({
    method: method,
    url: `${baseURL.value}/api/${path}${param}version=${process.env.REACT_APP_VERSION}`,
    data: data,
    headers: {
      ...(isFormData ? {} : { 'Content-Type': content }),
      Authorization: `bearer ${token.value}`,
    },
  });
};
